<template>
  <div class="container">
    <div class="row">
      <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
        <button type="button" class="btn btn-outline-main" @click="returnHome">
          <i class="fas fa-home-lg-alt"></i> Inicio
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <label
            ><b>Camara {{ isFront ? "Frontal" : "Trasera" }} activa</b></label
          >
          <button
            @click="toggleCamera"
            style="
              background: #1976d2;
              color: white;
              border: none;
              padding: 8px 12px;
              border-radius: 6px;
              cursor: pointer;
            "
          >
            <i class="fas fa-recycle"></i>
          </button>
        </div>
        <video
          ref="video"
          autoplay
          playsinline
          style="width: 100%; max-width: 300px; background: #000"
        ></video>
        <canvas ref="canvas" style="display: none"></canvas>
      </div>
      <div class="col-sm-9">
        <div class="table-responsive">
          <table class="table table-bordered border-main text-center align-middle">
            <thead>
              <tr>
                <th>PERSONAL</th>
                <th>DE INGRESO</th>
                <th>SALIDA DE ALMUERZO</th>
                <th>REGRESO DE ALMUERZO</th>
                <th>DE SALIDA</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ item.user.name }} {{ item.user.last_name }}</td>
                <td>{{ formatDateTime(item.in) }}</td>
                <td>{{ formatDateTime(item.out_receso) }}</td>
                <td>{{ formatDateTime(item.in_receso) }}</td>
                <td>{{ formatDateTime(item.out) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsQR from "jsqr";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-vigilancia-asistencia",
  data() {
    return {
      codeReader: null,
      isFront: false,
      data: [],
    };
  },
  mounted() {
    this.mtdStartCamera();
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome: function () {
      this.mtdStopScanning();
      this.$emit("returnHome");
    },
    toggleCamera() {
      this.isFront = !this.isFront;
      this.mtdStartCamera();
    },
    mtdStopCamera() {
    // Detener todos los tracks de la cámara
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }

    // Detener y limpiar el video
    if (this.$refs.video) {
      this.$refs.video.pause();
      this.$refs.video.srcObject = null;
    }

    // Si usas algún loop / intervalo para escaneo QR
    if (this.scanInterval) {
      clearInterval(this.scanInterval);
      this.scanInterval = null;
    }

    this.isScanning = false;
  },
    async mtdStartCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
      }
      const constraints = {
        video: {
          facingMode: this.isFront ? "user" : "environment",
        },
      };
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.$refs.video.srcObject = this.stream;

        // 🔥 Importante: cuando el video cargue, inicia el escaneo QR
        this.$refs.video.onloadedmetadata = () => {
          this.$refs.video.play();
          this.mtdStartScanning();
        };
      } catch (err) {
        console.error("Error encendiendo cámara:", err);
      }
    },
    mtdStartScanning() {
      this.scanInterval = setInterval(() => {
        this.scanning = true;

        const video = this.$refs.video;
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code) {
          const qrValue = code.data;
          // this.qrList.push(qrValue);
          console.log("QR detectado:", qrValue);
          // Aquí puedes ejecutar alguna acción por cada QR encontrado
          this.mtdStopScanning();
          this.mtdOnQRDetected(qrValue);
        }
      }, 400); // escanear cada 400ms
    },
    mtdStopScanning() {
      if (this.scanInterval) {
        clearInterval(this.scanInterval);
        this.scanInterval = null;
        this.lastQR = null;
      }
    },
    mtdOnQRDetected(data) {
      this.post({
        url: this.$store.getters.get__url + "/vigilance/getuser",
        token: this.$store.getters.get__token,
        params: {
          uuid: data,
        },
      })
        .then((response) => {
          const resultado = response.data.data;
          if (resultado != null) {
            this.mtdGetData();
            Swal.fire({
              title: response.data.msg,
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "QR invalido.",
              icon: "warning",
            });
          }
          this.mtdStartScanning();
        })
        .catch((errors) => {});
    },
    mtdGetData: function () {
      this.get({
        url: this.$store.getters.get__url + "/vigilance",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          console.log(response);
          this.data = response.data;
        })
        .catch((errors) => {});
    },
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(date){
      if (date != null) {
        let ar = date.split(" ");
        let dat = ar[0] != null ? moment(date).format("DD/MM/YYYY") : "-";
        return dat+" "+ar[1];
      }
    }
  },
  beforeDestroy() {
    this.mtdStopScanning();
    this.mtdStopCamera();
  },
};
</script>

<style lang="scss" scoped>
canvas {
  width: 100%;
  height: 100%;
}
</style>